import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

import ConfirmEmailView from "../modules/ConfirmEmail";

export default function ConfirmEmailPage() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <ConfirmEmailView />
    </Box>
  );
}
